import React, { useContext, useEffect, useMemo, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  calDebtCreditCard,
  calTotalCreditorFloatInterest,
  cn,
  generateAmortizationSchedule,
  round,
  toFloat2,
} from "../../utils/useFunctions";
import fontSarabunTH from "./font/fontSarabunTH";
import {
  STYLE_PAGE,
  STYLE_PAGE_LANDING,
  STYLE_PDF_CONTENT,
} from "./styles/pdf.style";
import PageLanding from "./view/pdf.v.pageLanding";
import PdfPageBalananceOne from "./view/pdf.v.pageBalanceOne";
import PdfPageBalananceTwo from "./view/pdf.v.pageBalanceTwo";
import PdfPageBalananceThree from "./view/pdf.v.pageBalanceThree";
import PdfPageBalananceFour from "./view/pdf.v.pageBalanceFour";
import PdfPageBalananceSeven from "./view/pdf.v.pageBalanceSeven";
import PageOverviewTwo from "./view/pdf.v.pageOverviewTwo";
import PdfPageBalananceSix from "./view/pdf.v.pageBalanceSix";
import PdfPageFinacialOne from "./view/pdf.v.pageFinacialOne";
import PdfPageFinacialTwo from "./view/pdf.v.pageFinalcialTwo";
import PdfPageFinacialLanding from "./view/pdf.v.pageFinalcialLanding";
import PdfPageRiskOne from "./view/pdf.v.pageRiskOne";
import PdfPageFamilyOne from "./view/pdf.v.pageFamilyOne";
import PdfPageFamilyTwo from "./view/pdf.v.pageFamilyTwo";
import PdfPageFamilyThree from "./view/pdf.v.pageFamilyThree";
import PdfPageInvestOne from "./view/pdf.v.pageInvestOne";
import PdfPageSavingOne from "./view/pdf.v.pageSavingOne";
import PdfPageFutureOne from "./view/pdf.v.pageFutureOne";
import PdfPageFutureTwo from "./view/pdf.v.pageFutureTwo";
import PdfPageFutureThree from "./view/pdf.v.pageFutureThree";
import PdfPageFutureFour from "./view/pdf.v.pageFutureFour";
import PdfPageDebtOne from "./view/pdf.v.pageDebtOne";
import PdfPageDebtTwo from "./view/pdf.v.pageDebtTwo";
import PdfPageDebtThree from "./view/pdf.v.pageDebtThree";
import PdfPageTaxOne from "./view/pdf.v.pageTaxOne";
import PdfPageTaxTwo from "./view/pdf.v.pageTaxTwo";
import PdfPageTaxSix from "./view/pdf.v.pageTaxSix";
import PdfPageEducationOne from "./view/pdf.v.pageEducation";
import PdfPageRetireOne from "./view/pdf.v.pageRetireOne";
import PdfPageRetireTwo from "./view/pdf.v.pageRetireTwo";
import PdfPageRetireThree from "./view/pdf.v.pageRetireThree";
import PdfPageOverviewOne from "./view/pdf.v.pageOverviewOne";
import PdfPageOverviewTwo from "./view/pdf.v.pageOverviewTwo";
import PdfPageOverviewThree from "./view/pdf.v.pageOverviewThree";
import PdfPageAssumeOne from "./view/pdf.v.pageAssumeOne";
import PdfPageOVIncomeOne from "./view/pdf.v.pageOVIncomeOne";
import PdfPageOVDebtOne from "./view/pdf.v.pageOVDebtOne";
import PdfPageOVExpenseOne from "./view/pdf.v.pageOVExpenseOne";
import PdfPageOVPropertyOne from "./view/pdf.v.pageOVPropertyOne";
import PdfPageAppendix from "./view/pdf.v.pageAppendix";
import PdfPageAppendixEducationOne from "./view/pdf.v.pageAppendixEducationOne";
import PdfPageInvestTwo from "./view/pdf.v.pageInvestTwo";
import PdfPageBalananceFive from "./view/pdf.v.pageBalanceFive";
import PdfPageInvestThree from "./view/pdf.v.pageInvestThree";
import PdfPageInvestFour from "./view/pdf.v.pageInvestFour";
import PdfPageInvestFive from "./view/pdf.v.pageInvestFive";
import PdfPageDebtOneSum from "./view/pdf.v.pageDebtOneSum";
import PdfPageDebtFour from "./view/pdf.v.pageDebtFour";
import PdfPageTaxThree from "./view/pdf.v.pageTaxThree";
import { useBalanceStore } from "../../_store/balanceStore";
import { useUserStore } from "../../_store/userStore";
import SalaryIncomePdf from "./premiumTax/salary.Income.pdf";
import { useTaxStore } from "../../_store/taxplanStore";
import QuitJobIncomePdf from "./premiumTax/quitjob.result.pdf";
import Income402Pdf from "./premiumTax/income402.pdf";
import Income406Pdf from "./premiumTax/income406.pdf";
import {
  DeductionSumPDF,
  ExceptionSumPDF,
  Income403PerPage,
  Income404PerPage,
  Income404StockPerPage,
  Income405PerPage,
  Income406PerPage,
  Income407PerPage,
  Income408PerPage,
  Income408PropertyPerPage,
  Income408ReciveDetailFunction,
  TaxHeirachyPDF,
} from "../../functions/pdfGenerateFunction/pdfFunction";
import Income403Pdf from "./premiumTax/income403.pdf";
import Income405Pdf from "./premiumTax/income405.pdf";
import Income408Pdf from "./premiumTax/income408.pdf";
import Income407Pdf from "./premiumTax/income407.pdf";
import Income408property from "./premiumTax/income408property.pdf";
import Income404Pdf from "./premiumTax/income404.pdf";
import Income408StockPdf from "./premiumTax/income404Stock.pdf";
import IncomeTaxNotIncludePdf from "./premiumTax/incomeTaxNotInclude.pdf";
import IncomeRMFPdf from "./premiumTax/incomeRMF.pdf";
import IncomeSSFPdf from "./premiumTax/incomeSSF.pdf";
import IncomeProfilePdf from "./premiumTax/incomeProfile.pdf";
import TaxDeductionPDF from "./premiumTax/taxDeduction.pdf";
import TaxHeirachy, {
  ExceptionLists,
} from "../../functions/taxFucntion/taxHeirachy";
import { C } from "react-flaticons";
import { generateSummary } from "../tax_plan/components/VIDeductionDrawerMain";
import { useTaxPlanContext } from "../tax_plan/Tax_Plan.Main";
import IncomeResultPDF from "./premiumTax/incomeResult.pdf";
import ExpenseFuturePDF from "./premiumFuture/expenseFuture.pdf";
import {
  ChildrenEducationExpensePDF,
  FutureCarExpensePDF,
  FutureChildrenExpensePDF,
  FutureCollectionExpensePDF,
  FutureETCExpensePDF,
  FutureHomeExpensePDF,
  FutureTravelExpensePDF,
  LegacyIncomePDF,
  OtherIncomePDF,
  PropertyIncomePDF,
  SellBusinessIncomePDF,
} from "../../functions/pdfGenerateFunction/pdfFutureFunction";
import { useFuturePlanStore } from "../../_store/futurePlanStore";
import TaxExceptionPDF from "./premiumTax/taxException.pdf";
import { useEducationStore } from "../../_store/educationStore";
import IncomeFuturePDF from "./premiumFuture/incomeFuture.pdf";
import ResultChartFuturePdf from "./premiumFuture/resultChartFuture.pdf";
import ResultLabelFuturePdf from "./premiumFuture/resultLabelFuture.pdf";
import { useRetireStore } from "../../_store/retireStore";
import { useDebtStore } from "../../_store/debtplanStore";
import PdfPageBalananceEight from "./view/pdf.v.pageBalanceSeven";
import PdfPageBalananceFourExtra from "./view/pdf.v.pageBalanceFourExtra";
import { useInsuranceStore } from "../../_store/insuranceStore";
import ExpenseInsuranceDetailPDF from "./Insurance/expenseInsuranceDetail.pdf";
import { formatPeriodTime } from "../debt/component/VIDebtTable";
import { options_debt } from "../balance/styles/Card";
import _ from "lodash";
import ExpenseInsuranceDetailTwoPDF from "./Insurance/expenseInsuranceDetailTwo.pdf";
import ExpenseInsuranceDetailThreePDF from "./Insurance/expenseInsuranceDetailThree.pdf";
import AllInsuranceNumber from "./Insurance/allInsuranceNumber";
import { InsureRanceLists } from "./Insurance/insureRanceLists";
import ExpenseInsuranceDetailFifthPDF from "./Insurance/expenseInsuranceDetailFifth.pdf";
import ExpenseInsuranceDetailFourPDF from "./Insurance/expenseInsuranceDetailFour.pdf ";
import ExpenseInsuranceDetailCarPDF from "./Insurance/expenseInsuranceDetailCar.pdf";
import ExpenseInsuranceDetailHomePDF from "./Insurance/expenseInsuranceDetailHome.pdf";
import ExpenseInsuranceDetailFirePDF from "./Insurance/expenseInsuranceDetailFire.pdf";
import { PdfContext } from "./context/pdf.ctx";
import { uploadData } from "aws-amplify/storage";
import api from "../../api/api.main";
import { DateTime } from "luxon";
import { ICON_LOADING } from "../../utils/useIcons";
import numeral from "numeral";
import PdfDownload from "./pdf.download";
import Income408Recive from "./premiumTax/income408Recive.pdf";
import Income408ReciveDetail from "./premiumTax/income408ReciveDetail.pdf";

const PDFPreviewer = () => {
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const userData = useUserStore((state) => state.userData);
  const taxData = useTaxStore((state) => state.taxData);
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const educationData = useEducationStore((state) => state.educationData);
  const retireData = useRetireStore((state) => state.retireData);
  const debtData = useDebtStore((state) => state.debtData);
  const insuranceData = useInsuranceStore((state) => state.insuranceData);

  const totalTaxDeduct = TaxHeirachyPDF(taxData)
    .filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        return item;
      }
      if (!ExceptionLists.includes(item?.title)) {
        return item;
      }
    })
    .reduce((sum, item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (item?.value2 >= 10000) {
          return sum + 10000;
        } else {
          return sum + item?.value2;
        }
      }

      return sum + item?.value2;
    }, 0);

  const totalException = TaxHeirachyPDF(taxData)
    .filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        return item;
      }
      if (ExceptionLists.includes(item?.title)) {
        return item;
      }
    })
    .reduce((sum, item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (item?.value2 >= 10000) {
          return sum + Number(item?.value2 || 0) - 10000;
        } else {
          return sum + Number(item?.value2 || 0);
        }
      }
      return sum + Number(item?.value2 || 0);
    }, 0);

  // const generatePDF = async () => {
  //   setIsSubmit(false);
  //   setLoadingPDF(true);
  //   pdfCtx.setPdfDate(new Date());

  //   const input = document.getElementById("pdf-content");

  //   doc.addFileToVFS("THSarabun.ttf", fontSarabunTH);
  //   doc.addFont("THSarabun.ttf", "THSarabun", "normal");
  //   doc.setFont("THSarabun");

  //   const pages = input.querySelectorAll(".page");

  //   for (let i = 0; i < pages.length; i++) {
  //     const page = pages[i];
  //     const canvas = await html2canvas(pages[i], {
  //       scale: 1.5,
  //       useCORS: true,
  //     });
  //     const image = canvas.toDataURL("image/png");
  //     const isHorizontal = page.classList.contains("page-horizontal");

  //     if (i !== 0) {
  //       // doc.addPage(null, "p");
  //       if (isHorizontal) {
  //         doc.addPage(null, "l");
  //       } else {
  //         doc.addPage(null, "p");
  //       }
  //     }

  //     const pageWidth = doc.internal.pageSize.getWidth();
  //     const pageHeight = doc.internal.pageSize.getHeight();

  //     const widthRatio = pageWidth / canvas.width;
  //     const heightRatio = pageHeight / canvas.height;
  //     const ratio = Math.min(widthRatio, heightRatio);

  //     const canvasWidth = canvas.width * ratio;
  //     const canvasHeight = canvas.height * ratio;

  //     const marginX = (pageWidth - canvasWidth) / 2;
  //     const marginY = (pageHeight - canvasHeight) / 2;
  //     doc.addImage(image, "PNG", marginX, marginY, canvasWidth, canvasHeight);
  //     setProgress((prev) => prev + 1);
  //   }

  //   const pdfBlob = doc.output("blob");
  //   await uploadData({
  //     key: `${userData?._id}.pdf`,
  //     data: pdfBlob,
  //   }).result;
  //   setProgress((prev) => prev + 1);

  //   await api.put(`/profiles/${userData._id}`, {
  //     is_export: true,
  //     export_date: DateTime.now().setZone("Asia/Bangkok").toISO(),
  //   });
  //   setProgress((prev) => prev + 1);
  //   setIsSubmit(true);

  //   // const input = document.getElementById("pdf-content");

  //   // const doc = new jsPDF("p", "px", "a4");
  //   // doc.addFileToVFS("THSarabun.ttf", fontSarabunTH);
  //   // doc.addFont("THSarabun.ttf", "THSarabun", "normal");
  //   // doc.setFont("THSarabun");

  //   // const pages = input.querySelectorAll(".page");

  //   // for (let i = 0; i < pages.length; i++) {
  //   //   const page = pages[i];
  //   //   const isHorizontal = page.classList.contains("page-horizontal");

  //   //   const canvas = await html2canvas(page, {
  //   //     scale: 1.7,
  //   //     useCORS: true,
  //   //   });
  //   //   const image = canvas.toDataURL("image/png");

  //   //   if (i !== 0) {
  //   //     // doc.addPage(null, "p");
  //   //     if (isHorizontal) {
  //   //       doc.addPage(null, "l");
  //   //     } else {
  //   //       doc.addPage(null, "p");
  //   //     }
  //   //   }

  //   //   const pageWidth = doc.internal.pageSize.getWidth();
  //   //   const pageHeight = doc.internal.pageSize.getHeight();

  //   //   const widthRatio = pageWidth / canvas.width;
  //   //   const heightRatio = pageHeight / canvas.height;
  //   //   const ratio = Math.min(widthRatio, heightRatio);

  //   //   const canvasWidth = canvas.width * ratio;
  //   //   const canvasHeight = canvas.height * ratio;

  //   //   const marginX = (pageWidth - canvasWidth) / 2;
  //   //   const marginY = (pageHeight - canvasHeight) / 2;
  //   //   doc.addImage(image, "PNG", marginX, marginY, canvasWidth, canvasHeight);
  //   // }

  //   // // doc.setProperties({
  //   // //   title: "invoice-pdf",
  //   // //   subject: "This is the subject",
  //   // //   author: "Author Name",
  //   // //   keywords: "generated, javascript, web 2.0, ajax",
  //   // //   creator: "kabir",
  //   // // });

  //   // const dataUri = doc.output("bloburi");
  //   // setPdfDataUri(dataUri);
  // };

  const debtShortItems = useMemo(() => {
    // console.log("1")
    const newDebtShortItems = [];

    if (balanceData?.debt_short_list?.length > 0) {
      for (const debt_short_item of balanceData?.debt_short_list) {
        const keys = Object.keys(debt_short_item);
        for (const key of keys) {
          if (_.isArray(debt_short_item[key])) {
            for (const item of debt_short_item[key]) {
              let createItem = {
                ...debt_short_item,
                ...item,
                title: "",
                unpaid_amount: item?.unpaid_amount,
                pay_permonth: item?.pay_permonth,
                interest: item?.interest,
                period: item?.period,
                period_time: "",
                type_payment: "",
                type_payment_ori: item?.type_payment,
                label: item?.creditor_name,
                status: options_debt?.find(
                  (option) => option?.value === item?.status
                ),
                unit_interest: "ต่อปี",
                sort: 0,
                customAmountOfInterest:
                  debt_short_item?.options_debt_short ===
                  "debt_informal_shortterm"
                    ? item?.start_amount * (item?.interest / 100)
                    : item?.unpaid_amount * (item?.interest / 100),
              };

              // เครดิตการ์ด
              if (debt_short_item?.options_debt_short === "debt_creditcard") {
                const creditor = calDebtCreditCard(item);
                const period = creditor?.creditor_items?.length;
                const typePayment = !item?.type_payment
                  ? ""
                  : item?.type_payment === "pay_minimum"
                  ? "จ่ายขั้นต่ำ(รายเดือน)"
                  : item?.type_payment === "pay_full"
                  ? "จ่ายเต็มจำนวน"
                  : "จ่ายแบบระบุจำนวน(รายเดือน)";
                createItem.period = !item?.type_payment ? "" : period;
                createItem.period_time = !item?.type_payment
                  ? ""
                  : formatPeriodTime(period);
                createItem.type_payment = typePayment;
                createItem.title = "บัตรเครดิต";
                createItem.sort = 1;
                createItem.customAmountOfInterest =
                  item?.type_payment === "pay_full"
                    ? 0
                    : creditor?.total_creditor_interest;
              }

              if (debt_short_item?.options_debt_short === "debt_shortterm") {
                const interest_min = toFloat2(
                  (item.unpaid_amount * item.interest) / 100
                );

                const loanDetails = generateAmortizationSchedule(
                  item.unpaid_amount,
                  item.interest,
                  item.pay_permonth
                );

                const totalInterest = loanDetails.reduce((acc, item) => {
                  return acc + item?.interestPayment;
                }, 0);
                const totalCreditor = round(
                  item?.unpaid_amount + totalInterest,
                  0
                );
                createItem.customAmountOfInterest = totalInterest;
                createItem.sort = 2;
                createItem.type_payment = "รายเดือน";
              } else if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.sort = 3;
                createItem.title = "หนี้นอกระบบ (รายวัน)";
                createItem.type_payment = "รายวัน";
                createItem.period = `${item?.number_of_days} วัน`;
              } else if (
                debt_short_item?.options_debt_short === "debt_shortterm_other"
              ) {
                const creditor = calTotalCreditorFloatInterest(item);
                const totalCreditorInterest = creditor.reduce(
                  (acc, item, index) => {
                    if (index > 11) {
                      return acc;
                    }
                    return acc + item.interest;
                  },
                  0
                );
                createItem.customAmountOfInterest = totalCreditorInterest;
                createItem.sort = 4;
                createItem.type_payment = "รายเดือน";
                createItem.unit_interest = "ต่อเดือน";
              }

              // เงินกู้ระยะสั้น, หนี้นอกระบบ, เงินกู้ระยะสั้นอื่นๆ
              if (
                [
                  "debt_shortterm",
                  "debt_informal_shortterm",
                  "debt_shortterm_other",
                ].includes(debt_short_item?.options_debt_short)
              ) {
                if (debt_short_item?.options_debt_short === "debt_shortterm") {
                  createItem.title = "หนี้กู้ระยะสั้น";
                } else if (
                  debt_short_item?.options_debt_short ===
                  "debt_informal_shortterm"
                ) {
                  createItem.title = "หนี้นอกระบบ";
                }
                createItem.period_time = formatPeriodTime(item?.period);
              }

              if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.unpaid_amount = item?.start_amount;
              }
              newDebtShortItems.push(createItem);
            }
          }
        }
      }
    }

    return newDebtShortItems.sort((a, b) => a.sort - b.sort);
  }, [balanceData]);

  const chunkDebtShortItems = useMemo(() => {
    const creditShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_creditcard"
      ) || [];
    const splitCreditShortItems = creditShortItems?.flatMap((item) => {
      const chunkCreditItems = _.chunk(item?.credit_cards, 1);
      const newShortItems = chunkCreditItems.map((creditItem) => {
        return {
          ...item,
          options_debt_short: "debt_creditcard",
          credit_cards: creditItem,
        };
      });
      return newShortItems;
    });
    const shortTermShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_shortterm"
      ) || [];
    const splitShortTermShortItems = shortTermShortItems?.flatMap((item) => {
      const chunkShortTermItems = _.chunk(item?.short_terms, 1);
      const newShortItems = chunkShortTermItems.map((shortItem) => {
        return {
          ...item,
          options_debt_short: "debt_shortterm",
          short_terms: shortItem,
        };
      });
      return newShortItems;
    });
    const informalShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_informal_shortterm"
      ) || [];
    const splitInformalShortItems = informalShortItems?.flatMap((item) => {
      const chunkInformalShortItems = _.chunk(item?.informal_short_terms, 1);
      const newShortItems = chunkInformalShortItems.map((informalItem) => {
        return {
          ...item,
          options_debt_short: "debt_informal_shortterm",
          informal_short_terms: informalItem,
        };
      });
      return newShortItems;
    });
    const otherShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_shortterm_other"
      ) || [];
    const splitOtherShortItems = otherShortItems?.flatMap((item) => {
      const chunkOtherShortItems = _.chunk(item?.short_term_others, 1);
      const newShortItems = chunkOtherShortItems.map((otherItem) => {
        return {
          ...item,
          options_debt_short: "debt_shortterm_other",
          short_term_others: otherItem,
        };
      });
      return newShortItems;
    });
    const carLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_car"
      ) || [];
    const splitCarLongItems = carLongItems?.flatMap((item) => {
      const chunkCarLongItems = _.chunk(item?.debt_long_cars, 1);
      const newLongItems = chunkCarLongItems.map((carItem) => {
        return {
          ...item,
          options_debt_long: "debt_car",
          debt_long_cars: carItem,
        };
      });
      return newLongItems;
    });
    const placeLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_place"
      ) || [];
    const splitPlaceLongItems = placeLongItems?.flatMap((item) => {
      const chunkPlaceLongItems = _.chunk(item?.debt_long_places, 1);
      const newLongItems = chunkPlaceLongItems.map((placeItem) => {
        return {
          ...item,
          options_debt_long: "debt_place",
          debt_long_places: placeItem,
        };
      });
      return newLongItems;
    });
    const otherLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_long_other"
      ) || [];
    const splitOtherLongItems = otherLongItems?.flatMap((item) => {
      const chunkOtherLongItems = _.chunk(item?.debt_long_others, 1);
      const newLongItems = chunkOtherLongItems.map((otherItem) => {
        return {
          ...item,
          options_debt_long: "debt_long_other",
          debt_long_others: otherItem,
        };
      });
      return newLongItems;
    });
    const newChunkDebtItems = _.chunk(
      [
        ...splitCreditShortItems,
        ...splitShortTermShortItems,
        ...splitInformalShortItems,
        ...splitOtherShortItems,
        ...splitCarLongItems,
        ...splitPlaceLongItems,
        ...splitOtherLongItems,
      ],
      2
    );
    return newChunkDebtItems;
  }, [balanceData]);

  let allPages = [
    <PdfPageOverviewOne page={1} userData={userData} />,
    <PdfPageOverviewTwo page={2} insuranceData={insuranceData} />,
    <PdfPageOverviewThree
      page={3}
      futurePlanData={futurePlanData}
      educationData={educationData}
      balanceData={balanceData}
      debtData={debtData}
    />,
    <PdfPageAssumeOne page={4} />,
    <PdfPageOVIncomeOne page={5} />,
    <PdfPageOVExpenseOne page={6} />,
    <PdfPageOVPropertyOne page={7} />,

    <PdfPageOVDebtOne page={8} />,

    <PdfPageBalananceOne page={9} />,
    <PdfPageBalananceTwo page={10} />,
    <PdfPageBalananceThree page={11} />,
    <PdfPageBalananceFour page={12} />,
    <PdfPageBalananceFourExtra page={12} />,
    <PdfPageBalananceFive page={13} />,
    <PdfPageBalananceSix page={14} />,
    <PdfPageBalananceEight page={15} />,

    <PdfPageFinacialOne page={16} />,
    <PdfPageFinacialTwo page={17} />,
    <PdfPageFinacialLanding page={18} />,

    <PdfPageRiskOne page={19} />,

    <PdfPageFamilyOne page={20} />,
    <PdfPageFamilyTwo page={21} />,
    <PdfPageFamilyThree page={22} />,

    <PdfPageRetireOne page={23} retireData={retireData} />,
    <PdfPageRetireTwo page={24} />,
    <PdfPageRetireThree page={25} userData={userData} />,
    <IncomeProfilePdf
      page={26}
      taxData={taxData?.RMF_Profit}
      userData={userData}
    />,
    <SalaryIncomePdf page={27} userData={userData} taxData={taxData} />,
  ];

  if (taxData?.tax_QuitJob?.isQuitJob) {
    allPages?.push(
      <QuitJobIncomePdf page={28} userData={userData} taxData={taxData} />
    );
  }

  allPages = [
    ...allPages,
    <Income402Pdf page={28} userData={userData} taxData={taxData} />,
  ];

  Income406PerPage(taxData?.freeJob)?.map((item, index) => {
    allPages.push(
      <Income406Pdf
        page={29}
        isFirst={index === 0}
        isLast={
          Income406PerPage(taxData?.freeJob)?.length === index + 1 &&
          taxData?.freeJob
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income403PerPage(taxData?.tax_403).map((item, index) => {
    if (
      index === 0 &&
      Income403PerPage(taxData?.tax_403)?.length === index + 1 &&
      taxData?.freeJob
        ?.map((item) => item?.calculating_method)
        ?.includes("หักตามจริง")
    ) {
      allPages.push(
        <Income403Pdf
          page={30}
          isFirst={index === 0}
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
      allPages.push(
        <Income403Pdf
          page={30}
          isLast={
            Income403PerPage(taxData?.tax_403)?.length === index + 1 &&
            taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง")
          }
          userData={userData}
          taxData={taxData}
          datalist={[]}
        />
      );
    }
    allPages.push(
      <Income403Pdf
        page={30}
        isFirst={index === 0}
        isLast={
          Income403PerPage(taxData?.tax_403)?.length === index + 1 &&
          taxData?.freeJob
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income405PerPage(taxData?.tax_405)?.map((item, index) => {
    allPages.push(
      <Income405Pdf
        page={31}
        isFirst={index === 0}
        isLast={
          Income405PerPage(taxData?.tax_405)?.length === index + 1 &&
          taxData?.freeJob
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income407PerPage(taxData?.tax_407)?.map((item, index) => {
    allPages.push(
      <Income407Pdf
        page={32}
        isFirst={index === 0}
        isLast={
          Income407PerPage(taxData?.tax_407)?.length === index + 1 &&
          taxData?.tax_407
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income408PerPage(taxData?.tax_408)?.map((item, index) => {
    if (
      Income408PerPage(taxData?.tax_408)?.length === index + 1 &&
      index === 0 &&
      taxData?.tax_408
        ?.map((item) => item?.calculating_method)
        ?.includes("หักตามจริง")
    ) {
      allPages.push(
        <Income408Pdf
          page={33}
          isFirst={index === 0}
          isLast={false}
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
      allPages.push(
        <Income408Pdf
          page={33}
          isLast={
            Income408PerPage(taxData?.tax_408)?.length === index + 1 &&
            taxData?.tax_408
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง")
          }
          userData={userData}
          taxData={taxData}
          datalist={[]}
        />
      );
    }

    allPages.push(
      <Income408Pdf
        page={33}
        isFirst={index === 0}
        isLast={
          Income408PerPage(taxData?.tax_408)?.length === index + 1 &&
          index !== 0 &&
          taxData?.tax_408
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income408PropertyPerPage(taxData?.tax_408_property)?.map((item, index) => {
    allPages.push(
      <Income408property
        page={34}
        isFirst={index === 0}
        isLast={
          Income408PerPage(taxData?.tax_408_property)?.length === index + 1 &&
          index !== 0 &&
          taxData?.freeJob
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income404PerPage(taxData?.tax_404)?.map((item, index) => {
    allPages.push(
      <Income404Pdf
        page={35}
        isFirst={index === 0}
        isLast={false}
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  Income404StockPerPage(taxData?.tax_404_stock)?.map((item, index) => {
    allPages.push(
      <Income408StockPdf
        page={36}
        isFirst={index === 0}
        isLast={
          Income408PerPage(taxData?.tax_404_stock)?.length === index + 1 &&
          taxData?.freeJob
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง")
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
        allList={taxData?.tax_404_stock}
      />
    );
  });

  if (taxData?.income_not_include_tax > 0) {
    allPages.push(<IncomeTaxNotIncludePdf page={37} taxData={taxData} />);
  }

  allPages = [
    ...allPages,
    <IncomeRMFPdf page={37} taxData={taxData?.RMF_Profit} />,
    <IncomeSSFPdf page={38} taxData={taxData?.SSF_Profit} />,
    <Income408Recive page={39} taxData={taxData} />,
  ];

  if (taxData?.heritage?.isPropertyDetail) {
    Income408ReciveDetailFunction(taxData?.heritage?.propertyDetail)?.map(
      (item, index) => {
        allPages.push(<Income408ReciveDetail page={39} allList={item} />);
      }
    );
  }

  allPages.push(
    <TaxDeductionPDF
      page={39}
      dataLength={TaxHeirachy(taxData)?.length}
      dataLengthLimit={10}
      data={TaxHeirachy(taxData)
        ?.filter((item) => item?.title !== "กองทุน กบข.")
        ?.sort((a, b) => a.sort - b.sort)
        ?.slice(0, 10)}
      head_1="จำนวนเงินที่ระบุ"
      total={totalTaxDeduct}
      totalException={totalException}
    />
  );

  if (TaxHeirachy(taxData)?.length > 10) {
    allPages.push(
      <TaxDeductionPDF
        page={39}
        dataLength={TaxHeirachy(taxData)?.length}
        dataLengthLimit={20}
        data={TaxHeirachy(taxData)
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(10, 18)}
        head_1="จำนวนเงินที่ระบุ"
        total={totalTaxDeduct}
        totalException={totalException}
      />
    );
  }

  if (TaxHeirachy(taxData)?.length > 18) {
    allPages.push(
      <TaxDeductionPDF
        page={39}
        dataLengthLimit={24}
        data={TaxHeirachy(taxData)
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(18)}
        head_1="จำนวนเงินที่ระบุ"
        total={totalTaxDeduct}
        totalException={totalException}
      />
    );
  }

  allPages = [
    ...allPages,
    <TaxExceptionPDF
      page={39}
      data={TaxHeirachy(taxData)?.sort((a, b) => a.sort - b.sort)}
      title="ค่ายกเว้นก่อนวางแผน"
      head_1="จำนวนเงินที่ระบุ"
      total={totalTaxDeduct}
      totalException={totalException}
    />,

    <TaxDeductionPDF
      page={40}
      title={"ค่าลดหย่อนหลังวางแผน"}
      dataLength={TaxHeirachy(taxData, () => {}, "four")?.length}
      dataLengthLimit={10}
      data={TaxHeirachy(taxData, () => {}, "four")
        ?.filter((item) => item?.title !== "กองทุน กบข.")
        ?.sort((a, b) => a.sort - b.sort)
        ?.slice(0, 10)}
      head_1="จำนวนเงินที่ระบุ"
      total={DeductionSumPDF(taxData)}
      totalException={ExceptionSumPDF(taxData)}
    />,
  ];

  if (TaxHeirachy(taxData, () => {}, "four")?.length > 10) {
    allPages.push(
      <TaxDeductionPDF
        page={40}
        dataLength={TaxHeirachy(taxData, () => {}, "four")?.length}
        dataLengthLimit={20}
        data={TaxHeirachy(taxData, () => {}, "four")
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(10, 18)}
        head_1="จำนวนเงินที่ระบุ"
        total={DeductionSumPDF(taxData)}
        totalException={ExceptionSumPDF(taxData)}
      />
    );
  }

  if (TaxHeirachy(taxData, () => {}, "four")?.length > 18)
    allPages.push(
      <TaxDeductionPDF
        page={40}
        dataLengthLimit={24}
        data={TaxHeirachy(taxData, () => {}, "four")
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(18)}
        head_1="จำนวนเงินที่ระบุ"
        total={DeductionSumPDF(taxData)}
        totalException={ExceptionSumPDF(taxData)}
      />
    );

  allPages = [
    ...allPages,
    <TaxExceptionPDF
      title="ค่ายกเว้นก่อนวางแผน"
      page={40}
      data={TaxHeirachy(taxData, () => {}, "four")?.sort(
        (a, b) => a.sort - b.sort
      )}
      head_1="จำนวนเงินที่ระบุ"
      total={DeductionSumPDF(taxData)}
      totalException={ExceptionSumPDF(taxData)}
    />,

    <IncomeResultPDF page={41} taxData={taxData} userData={userData} />,

    <PdfPageInvestOne page={42} />,
    <PdfPageInvestTwo page={43} />,
    <PdfPageInvestThree page={44} />,
    <PdfPageInvestFour page={45} />,
    <PdfPageInvestFive page={46} />,

    <PdfPageEducationOne page={47} />,

    <PdfPageSavingOne page={48} />,
  ];

  FutureHomeExpensePDF(futurePlanData?.expenese_home_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureHomeExpensePDF(futurePlanData?.expenese_home_items)
              ?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  FutureCarExpensePDF(futurePlanData?.expenese_car_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureCarExpensePDF(futurePlanData?.expenese_car_items)?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  FutureChildrenExpensePDF(futurePlanData?.expenese_children_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureChildrenExpensePDF(futurePlanData?.expenese_children_items)
              ?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
          ischileFuture={true}
        />
      );
    }
  );

  FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)
              ?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  FutureCollectionExpensePDF(futurePlanData?.expenese_collection_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureCollectionExpensePDF(
              futurePlanData?.expenese_collection_items
            )?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  FutureETCExpensePDF(futurePlanData?.expenese_other_items)?.map(
    (item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureETCExpensePDF(futurePlanData?.expenese_other_items)
              ?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  if (futurePlanData?.expenese_children_education?.length > 0) {
    ChildrenEducationExpensePDF(educationData)?.map((item, index) => {
      allPages.push(
        <ExpenseFuturePDF
          page={37}
          isChildrenEducation={true}
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });
  }

  LegacyIncomePDF(futurePlanData?.income_legacy_items)?.map((item, index) => {
    allPages.push(
      <IncomeFuturePDF
        page={37}
        isFirst={index === 0}
        isLast={
          LegacyIncomePDF(futurePlanData?.income_legacy_items)?.length ===
          index + 1
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  SellBusinessIncomePDF(futurePlanData?.income_business_items)?.map(
    (item, index) => {
      allPages.push(
        <IncomeFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            SellBusinessIncomePDF(futurePlanData?.income_business_items)
              ?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  PropertyIncomePDF(futurePlanData?.income_property_items)?.map(
    (item, index) => {
      allPages.push(
        <IncomeFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            PropertyIncomePDF(futurePlanData?.income_property_items)?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    }
  );

  OtherIncomePDF(futurePlanData?.income_other_items)?.map((item, index) => {
    allPages.push(
      <IncomeFuturePDF
        page={37}
        isFirst={index === 0}
        isLast={
          OtherIncomePDF(futurePlanData?.income_other_items)?.length ===
          index + 1
        }
        userData={userData}
        taxData={taxData}
        datalist={item}
      />
    );
  });

  allPages = [
    ...allPages,
    <ResultChartFuturePdf page={40} />,
    <ResultLabelFuturePdf page={40} />,
    <PdfPageFutureFour page={40} userData={userData} />,

    <PdfPageDebtOne page={41} />,
    <PdfPageDebtOneSum page={42} chunkDebtShortItems={chunkDebtShortItems} />,
    <PdfPageDebtTwo page={43} debtShortItems={debtShortItems} />,
    <PdfPageDebtThree page={44} />,
    <PdfPageDebtFour page={45} />,

    <PdfPageAppendix page={46} />,

    <PdfPageAppendixEducationOne page={47} />,

    <AllInsuranceNumber page={48} balanceData={balanceData} />,
  ];

  InsureRanceLists(balanceData)?.InsuranceLifes?.map((item, index) => {
    allPages.push(<ExpenseInsuranceDetailPDF page={48} data={item} />);
    allPages.push(<ExpenseInsuranceDetailTwoPDF page={48} data={item} />);
    allPages.push(<ExpenseInsuranceDetailThreePDF page={48} data={item} />);
    allPages.push(<ExpenseInsuranceDetailFourPDF page={48} data={item} />);
  });

  InsureRanceLists(balanceData)?.InsuranceAccidents?.map(
    (item, index) => {
      allPages.push(<ExpenseInsuranceDetailFifthPDF page={49} data={item} />)
    }
  )

  InsureRanceLists(balanceData)?.Insurancecars?.map(
    (item, index) => {
      allPages.push(<ExpenseInsuranceDetailCarPDF page={50} data={item} />)
    }
  )

  {InsureRanceLists(balanceData)?.InsuranceHomes?.map(
    (item, index) => {
      allPages.push( <ExpenseInsuranceDetailHomePDF page={51} data={item} />)
    }
  )}

  {InsureRanceLists(balanceData)?.InsuranceFires?.map(
    (item, index) => {
      allPages.push( <ExpenseInsuranceDetailFirePDF page={52} data={item} />)
    }
  )}




  return (
    <div className="h-screen">
      <PdfDownload />
      <div id="pdf-content" className={cn(STYLE_PDF_CONTENT)}>
        <PageLanding />

        {allPages?.map((item, index) => {
          return React.cloneElement(item, { page: index + 1 });
        })}

        
      </div>
      {pdfDataUri && (
        <iframe
          title="Preview PDF"
          style={{ width: "100%", height: "100%", margin: "0 auto" }}
          src={pdfDataUri}
        />
      )}
    </div>
  );
};

export default PDFPreviewer;
